import script from "./CreatorSetupTour.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorSetupTour.vue?vue&type=script&setup=true&lang=js"

import "./CreatorSetupTour.vue?vue&type=style&index=0&id=d8d46042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d46042"]])

export default __exports__